import React from 'react';
import { Formik } from 'formik';
import Page from '../components/Page';
import * as Yup from 'yup';

const ContatoSchema = Yup.object().shape({
   nome: Yup.string()
     .required('Digite o seu nome'),
   mensagem: Yup.string()
     .required('Digite uma mensagem'),
   email: Yup.string()
     .email('Email inválido')
     .required('Digite seu email'),
});

const Contato = () => {

   function submitForm(values, actions) {
      setTimeout(() => {
         alert(JSON.stringify(values, null, 2));
         actions.setSubmitting(false);
      }, 400);
   }
   
   return(
      <Page view="contato" bg="/assets/img/contato-bg.jpg">
         <h1>Entre em contato</h1>
         
         <div className="row">
            <div className="form-details col-md-5">
               <p>Entre em contato conosco para maiores informações.</p>
               <p>Ou nos mande uma mensagem!</p>
               <p>Vamos ficar em contato!</p>
               <p><strong>Email: <a className="link" href="mailto:covidfront@gmail.com">covidfront@gmail.com</a></strong></p>
            </div>
            <div className="col-md-7">
               <Formik
                  
                  initialValues={{ 
                     nome: '', 
                     email: '', 
                     mensagem: '' 
                  }}

                  validationSchema={ContatoSchema}

                  onSubmit={(values, { setSubmitting }) => submitForm(values, { setSubmitting })}
               >
                  {({
                     values,
                     errors,
                     touched,
                     handleChange,
                     handleBlur,
                     handleSubmit,
                     isSubmitting,
                  }) => (
                     <form className="form" onSubmit={handleSubmit}>
                        <div className="row">
                           <div className="col-md-6">
                              <div className="form-group">
                                 <label className="form-label" htmlFor="nome">Nome: <span className="form-required">*</span></label>
                                 <input
                                    className={`form-input ${ errors.nome && touched.nome ? 'is-invalid' : '' }`}
                                    type="text"
                                    name="nome"
                                    placeholder="Digite o seu nome"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.nome}
                                 />
                                 {errors.nome && touched.nome ? ( <span className="form-error"> {errors.nome} </span> ) : null}
                              </div>
                           </div>
                           <div className="col-md-6">
                              <div className="form-group">
                                 <label className="form-label" htmlFor="email">Email: <span className="form-required">*</span></label>
                                 <input
                                    className={`form-input ${ errors.email && touched.email ? 'is-invalid' : '' }`}
                                    placeholder="Digite o seu email"
                                    type="email"
                                    name="email"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.email}
                                 />
                                 {errors.email && touched.email ? ( <span className="form-error"> {errors.email} </span> ) : null}
                              </div>
                           </div>
                           <div className="col-md-12">
                              <div className="form-group">
                                 <label className="form-label" htmlFor="nome">Mensagem: <span className="form-required">*</span></label>
                                 <textarea
                                    className={`form-input ${ errors.mensagem && touched.mensagem ? 'is-invalid' : '' }`}
                                    placeholder="Digite uma mensagem"
                                    type="text"
                                    name="mensagem"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.messagem}
                                 ></textarea>
                                 {errors.mensagem && touched.mensagem ? ( <span className="form-error"> {errors.mensagem} </span> ) : null}
                              </div>
                           </div>
                        </div>
                        <button className="button button--primary" type="submit" disabled={isSubmitting}>Enviar</button>
                     </form>
                  )}
               </Formik>
            </div>
         </div>
      </Page>
   )
}

export default Contato;